import { FormFields, FormHeader, FormSection } from '../form';
import { UndergroundDamage } from './UndergroundDamage';
import { useValidation } from '../../../../hooks';
import { ListBox } from '../../../../components';
import { claimFields } from '../../../../config';
import { AerialDamage } from './AerialDamage';

import type { Dispatch, FC, SetStateAction } from 'react';
import type { ILocationType } from '../../../../types';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

interface IDamageTypeProps {
  locationTypes: Array<ILocationType>;
  setSaveAndQuitChanges?: Dispatch<SetStateAction<Array<string>>>;
}

export const DamageType: FC<IDamageTypeProps> = ({ locationTypes, setSaveAndQuitChanges }) => {
  const { fieldRequirements } = useValidation({});
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  return (
    <FormSection>
      <FormHeader>{localization.translate('damageType.header')}</FormHeader>

      <FormFields>
        {/* LOCATION TYPE */}
        <ListBox
          isRequired={fieldRequirements.DamageLocationType}
          label={localization.translate('damageType.locationLabel')}
          listItems={locationTypes}
          name={claimFields.damageLocationType}
          onSingleChange={(_) => setSaveAndQuitChanges?.((prev) => [...prev, 'DamageLocationTypeId'])}
          tooltip={localization.translate('damageType.locationTooltip')}
        />

        {/* AERIAL DAMAGE */}
        <AerialDamage setSaveAndQuitChanges={setSaveAndQuitChanges} />

        {/* UNDERGROUND DAMAGE */}
        <UndergroundDamage setSaveAndQuitChanges={setSaveAndQuitChanges} />
      </FormFields>
    </FormSection>
  );
};